
export const initialState = { 
    statusNewBudget: false,
    statusNewClient:false,
    statisNewClaimTicket:false,
    satusConfirmMessage:false,
    statusNewItem:false,
    statusViewBudget:false,
    statusViewClaim: false,
    statusEditQuantity:false,
    statusViewUser:false,
    statusNewUser:false,
    statusEditItem:false,
    statusViewClient:false,
    statusAddObjectType:false,
    statusViewProcess:false,
};

export function reducer(state, action) {
    switch (action.type) {
        case 'openViewProcess':
            return {...state, statusViewProcess:true};
        case 'closeViewProcess':
            return {...state, statusViewProcess:false};
        case 'openAddObjectType':
            return {...state, statusAddObjectType:true};
        case 'closeAddObjectType':
            return {...state, statusAddObjectType:false};
        case 'openViewClient':
            return {...state, statusViewClient:true};
        case 'closeViewClient':
            return {...state, statusViewClient:false};
        case 'openEditQuantity':
            return {...state, statusEditQuantity:true};
        case 'closeEditQuantity':
            return {...state, statusEditQuantity:false};
        case 'openViewClaim':
            return {...state, statusViewClaim:true};
        case 'closeViewClaim':
            return {...state, statusViewClaim:false};
        case 'openNewClaimTicket':
            return {...state, statusNewClaimTicket: true};
        case 'closeNewClaimTicket':
            return {...state, statusNewClaimTicket: false};
        case 'openEditItem':
            return {...state, statusEditItem: true};
        case 'closeEditItem':
            return {...state, statusEditItem: false};
        case 'openNewUser':
            return {...state,statusNewUser: true};
        case 'closeNewUser':
            return {...state,statusNewUser: false};
        case 'openViewUser':
            return {...state,statusViewUser: true};
        case 'closeViewUser':
            return {...state,statusViewUser: false};
        case 'openNewItem':
            return {...state, statusNewItem: true};
        case 'closeNewItem':
            return {...state, statusNewItem: false};
        case 'openNewClient':
            return {...state, statusNewClient: true};
        case 'closeNewClient':
            return {...state, statusNewClient: false};
        case 'openViewBudget':
            return {...state, statusViewBudget: true};
        case 'closeViewBudget':
            return {...state, statusViewBudget: false};
        case 'closeNewBudget':
            return { ...state, statusNewBudget: false }; // Spread previous state
        case 'openNewBudget':
            return { ...state, statusNewBudget: true };  // Spread previous state
        case 'closeConfirmMessage':
            return { ...state, statusConfirmMessage: false }; // Spread previous state
        case 'openConfirmMessage':
            return { ...state, statusConfirmMessage: true };  // Spread previous state
        default:
            throw new Error(`Unknown action type: ${action.type}`); // Include action type in the error message
    }
}